import { mutation_keys } from "../mutations";

/**
 * User action keys
 * @type {import("../types/actions/user").UserActionKeys}
 */
const user_action_keys = {
    "SET": "USER/SET",
    "SET_LOCALE": "USER/SET_LOCALE"
}

/**
 * User specific actions.
 * @type {import("../types/actions/user").UserActions}
 */
const user_actions = {
    /** Setting authenticated user. */
    [user_action_keys.SET]({ commit }, user) {
        commit(mutation_keys.user.SET, user);

        window.TrustUpBase.setup();
        window.Planning.setup();
        window.Worksite.setup();
    },
    /** Setting authenticated user locale. */
    [user_action_keys.SET_LOCALE]({ commit }, locale) {
        commit(mutation_keys.user.SET_LOCALE, locale);
    }
};

export { user_action_keys };

export default user_actions;